module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/serviceregister/leave-balance-details/leave-bal-det-grid/leave-bal-det-grid.component.css
// module id = ./src/app/hrms/serviceregister/leave-balance-details/leave-bal-det-grid/leave-bal-det-grid.component.css
// module chunks = main